"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourcePathMixin = void 0;
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var source_adapter_1 = require("./source-adapter");
var source_path_adapter_1 = require("./source-path-adapter");
// @ts-ignore
var SourcePathMixin = /** @class */ (function (_super) {
    __extends(SourcePathMixin, _super);
    function SourcePathMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SourcePathMixin.prototype.onLabelChanged = function (label) {
        this.onOverrideValueChanged(label, String);
    };
    SourcePathMixin.prototype.onHelptextChanged = function (helptext) {
        this.onOverrideValueChanged(helptext, String);
    };
    SourcePathMixin.prototype.onReadonlyChanged = function (readonly) {
        this.onOverrideValueChanged(readonly, Boolean);
    };
    SourcePathMixin.prototype.onRequiredChanged = function (required) {
        this.onOverrideValueChanged(required, Boolean);
    };
    Object.defineProperty(SourcePathMixin.prototype, "$source", {
        get: function () {
            // If the source is an adapter, then potentially apply overrides, and return it
            if ((0, source_adapter_1.isSourceAdapter)(this.source)) {
                this.ensureOverridesAppliedToSourceAdapter(this.source);
                return this.source;
            }
            return new source_path_adapter_1.SourcePathAdapter({ parent: this, propsData: { source: this.source, overrides: this } });
        },
        enumerable: false,
        configurable: true
    });
    SourcePathMixin.prototype.ensureOverridesAppliedToSourceAdapter = function (source) {
        var hasOverrides = (0, source_adapter_1.hasOverrideValue)(this.label, String) || (0, source_adapter_1.hasOverrideValue)(this.helptext, String) || (0, source_adapter_1.hasOverrideValue)(this.readonly, Boolean) || (0, source_adapter_1.hasOverrideValue)(this.required, Boolean);
        if ((0, source_adapter_1.isSourcePathAdapter)(source)) {
            if (hasOverrides) {
                if (source.overrides && source.overrides !== this) {
                    throw new Error("Overrides have already been applied to source of type '" + source.constructor.name + "'.");
                }
                // Apply the given overrides as the overrides for the source
                source.overrides = this;
            }
        }
        else {
            if (hasOverrides) {
                throw new Error("Cannot apply overrides to source of type '" + source.constructor.name + "'.");
            }
        }
    };
    SourcePathMixin.prototype.onOverrideValueChanged = function (value, type) {
        // If the source is an adapter, and an override value is set, then ensure that the
        if ((0, source_adapter_1.isSourceAdapter)(this.source) && (0, source_adapter_1.hasOverrideValue)(value, type)) {
            this.ensureOverridesAppliedToSourceAdapter(this.source);
        }
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: [String, Object] }),
        __metadata("design:type", Object)
    ], SourcePathMixin.prototype, "source", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)(String),
        __metadata("design:type", String)
    ], SourcePathMixin.prototype, "label", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)("label"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SourcePathMixin.prototype, "onLabelChanged", null);
    __decorate([
        (0, vue_property_decorator_1.Prop)(String),
        __metadata("design:type", String)
    ], SourcePathMixin.prototype, "helptext", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)("helptext"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SourcePathMixin.prototype, "onHelptextChanged", null);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Boolean, default: null }),
        __metadata("design:type", Boolean)
    ], SourcePathMixin.prototype, "readonly", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)("readonly"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SourcePathMixin.prototype, "onReadonlyChanged", null);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Boolean, default: null }),
        __metadata("design:type", Boolean)
    ], SourcePathMixin.prototype, "required", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)("required"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SourcePathMixin.prototype, "onRequiredChanged", null);
    SourcePathMixin = __decorate([
        vue_property_decorator_1.Component
    ], SourcePathMixin);
    return SourcePathMixin;
}(vue_1.default));
exports.SourcePathMixin = SourcePathMixin;
